// Mirrors conductor-web's lib/i18n/config.ts — same three locales, same shape,
// kept as a separate copy since the two apps don't share a package. Adding a
// fourth locale means updating BOTH copies plus a messages/<code>.json here.
export const LOCALES = ["en", "it", "bs"] as const;
export type Locale = (typeof LOCALES)[number];

// Italian is the platform default: signed-out visitors, new accounts and any
// account without a stored choice. It does NOT follow Accept-Language.
export const DEFAULT_LOCALE: Locale = "it";

// The signed-out language choice (the switcher under the login / landing
// pages). Only read while there's no session: once signed in, the account's
// stored language wins (lib/i18n/request.ts).
export const LOCALE_COOKIE = "cp_locale";

// Native names — what the client sees in the Settings language switcher.
export const LOCALE_LABELS: Record<Locale, string> = {
  en: "English",
  it: "Italiano",
  bs: "Bosanski",
};

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}
